import { render, staticRenderFns } from "./PixelPartners.vue?vue&type=template&id=726076c2&"
import script from "./PixelPartners.vue?vue&type=script&lang=js&"
export * from "./PixelPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports